<template>
  <div v-if="!dismissed" class="px-banner-gestao">
    <v-card
      v-if="variant === 'card'"
      class="rounded-card-small mb-3"
      flat
      outlined
    >
      <div class="d-flex align-center banner-card">
        <div class="banner-card__accent" />
        <v-icon color="primary" class="mx-3">mdi-rocket-launch-outline</v-icon>
        <div class="flex-grow-1 py-2">
          <div class="body-2 font-weight-medium">
            Fornecedor, saiba como podemos ajudar o setor de compras da sua empresa
          </div>
          <div class="caption text--secondary">
            Clique em "Saiba Mais" e conheça a Proxpect, uma plataforma completa
            para gestão de compras
          </div>
        </div>
        <v-btn
          small
          text
          color="primary"
          class="mr-2 normal-btn-text"
          :href="bannerUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          Saiba mais
          <v-icon small right>mdi-open-in-new</v-icon>
        </v-btn>
        <v-btn icon x-small class="mr-2" @click="dismiss">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card>
    <div v-if="variant === 'inline'" class="d-flex align-center justify-center mb-3 banner-inline">
      <v-icon x-small color="primary" class="mr-1">mdi-information-outline</v-icon>
      <span class="caption text--secondary">
        O Setor de compras da sua empresa sofre com tarefas manuais?
        Saiba como a Proxpect pode solucionar esse problema
        <a
          :href="bannerUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="primary--text"
        >clicando aqui</a>
      </span>
      <v-btn icon x-small class="ml-1" @click="dismiss">
        <v-icon x-small>mdi-close</v-icon>
      </v-btn>
    </div>

  </div>
</template>

<script>
const BANNER_DISMISSED_KEY = 'px_banner_gestao_dismissed';

export default {
  props: {
    variant: {
      type: String,
      default: 'card',
      validator: v => ['card', 'inline'].includes(v),
    },
  },
  data() {
    return {
      dismissed: false,
    };
  },
  computed: {
    bannerUrl() {
      return 'https://lp.proxpect.com.br/fornecedores/';
    },
  },
  methods: {
    dismiss() {
      this.dismissed = true;
      try {
        sessionStorage.setItem(BANNER_DISMISSED_KEY, 'true');
      } catch (e) {
        // sessionStorage not available
      }
    },
  },
  created() {
    try {
      this.dismissed = sessionStorage.getItem(BANNER_DISMISSED_KEY) === 'true';
    } catch (e) {
      // sessionStorage not available
    }
  },
};
</script>

<style scoped>
.banner-card {
  min-height: 48px;
}

.banner-card__accent {
  width: 4px;
  align-self: stretch;
  background-color: var(--v-primary-base);
  border-radius: 15px 0 0 15px;
}

.banner-inline {
  opacity: 0.85;
}
</style>
